var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppleMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3217 0H2.46714C1.42411 0 0.577881 0.815116 0.577881 1.81979V15.1649C0.577881 16.1696 1.42411 16.9847 2.46714 16.9847H16.3217C17.3648 16.9847 18.211 16.1696 18.211 15.1649V1.81979C18.211 0.815116 17.3648 0 16.3217 0ZM15.2629 12.966C15.0465 13.857 14.3459 14.3574 13.4052 14.5242C12.5786 14.6721 11.8898 14.7062 11.2325 14.1944C10.4257 13.5423 10.4178 12.4618 11.142 11.7794C11.7166 11.2524 12.5196 11.1462 13.7319 10.9415C13.9326 10.9074 14.1097 10.8619 14.2593 10.7027C14.4758 10.4676 14.4088 10.57 14.4088 5.40251C14.4088 5.03855 14.2239 4.93998 13.8342 5.00443C13.5587 5.04993 7.57602 6.12664 7.57602 6.12664C7.23359 6.19867 7.12338 6.29725 7.12338 6.66879C7.12338 14.2892 7.15881 13.9404 7.04073 14.4446C6.89903 15.036 6.52118 15.4796 6.02131 15.7261C5.45454 16.0294 4.43119 16.162 3.88409 16.0635C2.42778 15.8019 1.91611 14.1792 2.90403 13.2504C3.47868 12.7234 4.28162 12.6172 5.4939 12.4125C5.69463 12.3784 5.87175 12.3329 6.02131 12.1737C6.35981 11.7983 6.08035 3.84052 6.19843 3.40074C6.22598 3.23393 6.30077 3.08986 6.43853 2.9837C6.58022 2.86997 6.83606 2.80552 6.89116 2.80552C13.7673 1.56578 14.6056 1.40655 14.7237 1.40655C15.1094 1.38001 15.3338 1.5999 15.3338 1.97903C15.3299 13.1632 15.3613 12.5604 15.2629 12.966Z",
    fill: "#6A3926"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_55"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.577881,
    width: 17.6331,
    height: 16.9847,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleMusic);
export default __webpack_public_path__ + "static/media/apple_music.d2c043b45149fe110e855e0299ee6d20.svg";
export { ForwardRef as ReactComponent };